<template>
    <!-- 市场情绪 -->
    <div class="statistics">
        <div class="row-aline">
            <div>
                <div class="row-four">北向资金净流入直方图</div>
                <div class="chart" id="bxlr"></div>
            </div>
            <div>
                <div class="row-four">股票市场成交额</div>
                <chart :option="optionBxcj" id="bxcj" style="width: 509px;height: 316px;"></chart>
                <!-- <div class="chart" id="bxcj"></div> -->
            </div>
        </div>
        <div class="row-aline">
            <div>
                <div class="row-four">期权持仓量PCR</div>
                <div class="chart" id="qqccl1"></div>
            </div>
            <div class="chart" id="qqccl2" style="margin-top:62px;"></div>
        </div>
        <div class="row-aline">
            <div class="chart mt0" id="qqccl3"></div>
            <div class="chart mt0" id="qqccl4"></div>
        </div>
        <div class="row-aline">
            <div>
                <div class="row-four">
                    隐含波动率
                    <el-upload class="row-one-more" action :show-file-list="false" :on-progress="worthImport">数据更新<i class="el-icon-refresh"></i></el-upload>
                    <a class="row-one-more" href="https://kingfund.myfund.com/files/隐含波动率导入模板.xlsx" target="_blank" download="隐含波动率导入模板">隐含波动率导入模板<i class="el-icon-bottom"></i></a>
                </div>
                <div class="chart" id="yhbd1"></div>
            </div>
            <div class="chart" id="yhbd2" style="margin-top:62px;"></div>
        </div>
        <div class="row-aline">
            <div class="chart mt0" id="yhbd3"></div>
            <div class="chart mt0" id="yhbd4"></div>
        </div>
        <div>
            <div class="row-four">基差走势图（当月）</div>
            <div class="chart" style="width: 1120px;" id="jczs"></div>
        </div>
        <div class="mt30">
            <div class="row-four">基差走势图（次月）</div>
            <div class="chart" style="width: 1120px;" id="jczsc"></div>
        </div>
        <div class="mt50">
            <div class="row-four">十年国债的股债利差与指数（沪深300）</div>
            <div class="chart" style="width: 1120px;" id="gzlc1"></div>
        </div>
        <div class="mt50">
            <div class="row-four">十年国债的股债利差与指数（上证50）</div>
            <div class="chart" style="width: 1120px;" id="gzlc2"></div>
        </div>
    </div>
</template>
<script>
import chart from "../../components/chart.vue";
export default {
    name: "marketStatistics",
    components:{
        chart
    },
  data () {
    return {
        optionBxcj: {
            title: { subtext: '金额（亿）' },
            legend: { show: false },
            grid: {
                left: '3%',right: '4%',bottom: '15%',containLabel: true
            },
            color:['#01567F'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'none' //滑动显示的柱状图阴影
                },
                formatter: function (params) {
                    var result = "";
                    params.forEach(function (item) {
                    result += '<span>' + item.name + '：</span><span>' + parseFloat(item.data).toFixed(2) + '</span>'
                    });
                    return result;
                }
            },
            xAxis: {
                type: 'category',
                axisLabel: { fontSize: 12, color: "#333",},
                axisTick: { show: false },
                data: []
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: function (val) { return val},
                    fontSize: 14, color: '#333'
                }
            },
            series: [],
            dataZoom:[
                {
                    type:'inside',
                    start:0,
                    end:100
                },
                {   
                    start:0,
                    end:100,
                    bottom:'5%',
                    height:6,
                    handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '250%',
                    borderColor:'transparent',
                    backgroundColor:'#e9eef2',
                    fillerColor:'#CBD3DA',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: '#CBD3DA',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2
                    },
                    showDetail:false,
                    brushSelect:false,
                }
            ]
        }
    }
  },
    mounted() {  
        this.getNbNetInflowAmount()
        this.getOptionPositionPCR()
        this.getNbNetTotalAmount()
        this.getIndexBasis()
        this.getnextIndexBasis()
        this.getImpliedVolatility()
        this.getStockBondSpread()
    },
    methods: {
        // 北向资金净流入直方图
        getNbNetInflowAmount() {
            let vm = this
            this.$http.post(this.$apiPath.GetNbNetInflowAmount, {}).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = []
                    res.data.data.dateList.forEach(item => {
                        xdata.push(item.replace(/-/g,"/"))
                    })
                    let series = {
                        type: 'bar',
                        barWidth: 8, //柱状图宽度
                        // label: {show: true,position: 'top',color:'#01567F'},
                        data: res.data.data.dataList,
                    }
                    vm.$commonEcharts.echartsSeven('bxlr', xdata, series,false, ['#01567F'])
                }
            }).catch(err => {})
        },
        // 北向资金成交量
        getNbNetTotalAmount() {
            let vm = this
            this.$http.post(this.$apiPath.GetNbNetTotalAmount, {}).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = []
                    res.data.data.dateList.forEach(item => {
                        xdata.push(item.replace(/-/g,"/"))
                    })
                    let series = {
                        // name: '成交量',
                        type: 'line',showSymbol: false,
                        data: res.data.data.dataList,
                        areaStyle:{
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: '#FFF'
                                },
                                {
                                    offset: 1,
                                    color: '#01567F'
                                }
                            ])
                        },
                    }
                    vm.optionBxcj.xAxis.data = xdata
                    vm.optionBxcj.series = series
                }
            }).catch(err => {})
        },
        // 期权持仓量PCR
        getOptionPositionPCR() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetOptionPositionPCR, {}).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = res.data.data.list
                    let seriesData = [[],[],[],[]]
                    for(let i = 0; i < xdata.length; i++) {
                        xdata[i].nameList.forEach((item1,i1) => {
                            seriesData[i].push({
                                name:item1,
                                yAxisIndex: i1,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:xdata[i].dataList[i1]
                            })
                        })
                    }
                    vm.$commonEcharts.echartsMultiY('qqccl1', xdata[0].dateList, seriesData[0]);
                    vm.$commonEcharts.echartsMultiY('qqccl2', xdata[1].dateList, seriesData[1],false,['#FF7800','#00B4FF']);
                    vm.$commonEcharts.echartsMultiY('qqccl3', xdata[2].dateList, seriesData[2],false,['#A622EB','#00B4FF']);
                    vm.$commonEcharts.echartsMultiY('qqccl4', xdata[3].dateList, seriesData[3],false,['#FFBA00','#1255CF']);
                }
            }).catch(err => {})
        },
        // 隐含波动率
        getImpliedVolatility() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetImpliedVolatility, {}).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = res.data.data.list
                    let seriesData = [[],[],[],[]]
                    for(let i = 0; i < xdata.length; i++) [
                        xdata[i].nameList.forEach((item1,i1) => {
                            seriesData[i].push({
                                name:item1,
                                yAxisIndex: i1,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:xdata[i].dataList[i1]
                            })
                        })
                    ]
                    vm.$commonEcharts.echartsMultiY('yhbd1', xdata[0].dateList, seriesData[0]);
                    vm.$commonEcharts.echartsMultiY('yhbd2', xdata[1].dateList, seriesData[1],false,['#FF7800','#00B4FF']);
                    vm.$commonEcharts.echartsMultiY('yhbd3', xdata[2].dateList, seriesData[2],false,['#A622EB','#00B4FF']);
                    vm.$commonEcharts.echartsMultiY('yhbd4', xdata[3].dateList, seriesData[3],false,['#FFBA00','#1255CF']);
                }
            }).catch(err => {})
        },
        worthImport(event, file, fileList) {
            let vm = this
            vm.$commonJs.getBase64(file.raw).then(result => {
                vm.$http.post(vm.$apiPath.AddedMarketExcel,{
                    FileName: file.name,    //文件名称
                    FileFlow: result,  //文件Base64字符串
                    FileType: 1,    //文件类型，列表接口里获取的值
                }).then(res => {
                    // console.log(res);
                    if(res.data.data.note) {
                        vm.$message.success('净值表导入成功')
                    } else {
                        vm.$message.error('净值表导入失败')
                    }
                }).catch(err => {})
            });
            return
        },
        //  基差走势图
        getIndexBasis() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetIndexBasis, {}).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = res.data.data
                    let seriesData = []
                    let symbolList=['circle','rect','triangle'];
                    xdata.nameList.forEach((item,i) => {
                        seriesData.push({
                            name:item,
                            type:'line',symbol:symbolList[i],showSymbol: false,symbolSize:8,
                            data:xdata.dataList[i]
                        })
                    })
                    vm.$commonEcharts.echartsWeightX('jczs', xdata.dateList, seriesData);
                }
            }).catch(err => {})
        },
        getnextIndexBasis() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetnextIndexBasis, {}).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = res.data.data
                    let seriesData = []
                    let symbolList=['circle','rect','triangle'];
                    xdata.nameList.forEach((item,i) => {
                        seriesData.push({
                            name:item,
                            type:'line',symbol:symbolList[i],showSymbol: false,symbolSize:8,
                            data:xdata.dataList[i]
                        })
                    })
                    vm.$commonEcharts.echartsWeightX('jczsc', xdata.dateList, seriesData);
                }
            }).catch(err => {})
        },
        // 股债利差与指数走势图
        getStockBondSpread() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetStockBondSpread, {}).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = res.data.data.list
                    let seriesData = [[],[]]
                    let color = ['#FF0909','#00B4FF','#FF7800','#C000FF','#FFBA00','#7DBA1C','#1255CF']
                    for(let i = 0; i < xdata.length; i++) {
                        xdata[i].nameList.forEach((val,ind) => {
                            if(ind != 6) {
                                seriesData[i].push({
                                    name:val,
                                    yAxisIndex: 0,
                                    type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                    data:xdata[i].dataList[ind]
                                })
                            } else if(ind == 6) {
                                seriesData[i].push({
                                    name:val,
                                    yAxisIndex: 1,
                                    type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                    data:xdata[i].dataList[ind]
                                })
                            }
                        })
                    }
                    vm.$commonEcharts.echartsMultiY('gzlc1', xdata[0].dateList, seriesData[0],false,color,true);
                    vm.$commonEcharts.echartsMultiY('gzlc2', xdata[1].dateList, seriesData[1],false,color,true);
                }
            }).catch(err => {})
        }
    }
}
</script>

<style lang="less" scoped>
.statistics {
    .mt0 {margin-top: 0!important;}
    .chart {width: 509px;height: 316px;margin-top: 32px;}
    .row-aline {display: flex;justify-content: space-between;margin-bottom: 60px;}
    .row-one-more {
        margin-left: 20px;font-size: 16px;float: none;
        /deep/.el-upload {color: @mainColor;}
    }
}
</style>